import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const selector = (state: ApplicationState) => {
    return state.context.website;
};
